import styles from './Layout.module.css'

export function PageHeader({ title, subtitle, context, breadcrumbs, status, badge, primaryAction, secondaryActions, actions, mode = 'default', compact = false, className = '' }) {
  const allActions = actions || (primaryAction || secondaryActions ? <><span className={styles.secondaryActions}>{secondaryActions}</span>{primaryAction}</> : null)
  return (
    <header className={`${styles.pageHeader} ${compact || mode === 'compact' ? styles.pageHeaderCompact : ''} ${mode === 'workspace' ? styles.pageHeaderWorkspace : ''} ${className}`.trim()} data-page-header-mode={mode} data-variant={compact ? 'minimal' : mode}>
      {breadcrumbs || context ? <div className={styles.headerContext}>{breadcrumbs || context}</div> : null}
      <div className={styles.headerMain}>
        <div className={styles.headerCopy}>
          <div className={styles.titleRow}>
            <h1 className={styles.title}>{title}</h1>
            {status || badge}
          </div>
          {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
        </div>
        {allActions ? <div className={styles.headerActions}>{allActions}</div> : null}
      </div>
    </header>
  )
}
